import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PlayerDto } from './player.schema';
import {
  queryOptions,
} from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { playerApi } from './player.api';

export const playerQueryOptions = {
  /**
   * Fetch the profile of the current player.
   */
  mePlayerProfile: (options?: QueryOptionsOverride<PlayerDto>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerProfile],
    queryFn: () => playerApi.getMePlayerProfile(),
    ...options,
  }),

};
